module.exports = __webpack_public_path__ + "img/icons-time.7aba8f26.svg";